import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { getProductNewPrice, getProductOldPrice } from './utils/cart.js';
import { extractVariantsFromProductName } from './utils/product.js';
import { CoreContext } from './context/index.js';

const MiniShoppingCartItem = ({ item, index }) => {
    var _a, _b;
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const router = useRouter();
    const { data: { siteConfig: { noZeroAfterDecimal = false }, }, } = useContext(CoreContext);
    const { price } = item.prices;
    const currencyCode = price.currency;
    const locale = router.locale;
    const newPrice = getProductNewPrice(item, currencyCode, locale, noZeroAfterDecimal, item.quantity);
    const oldPrice = getProductOldPrice(item, currencyCode, locale, noZeroAfterDecimal, item.quantity);
    const variants = extractVariantsFromProductName({ name: (_a = item.configured_variant) === null || _a === void 0 ? void 0 : _a.name });
    const variantsArray = variants ? variants.split(';') : [];
    return (React.createElement("div", { className: "shopping-bag-item", key: item.id },
        React.createElement("div", { className: "product-quantity", "aria-label": `${tLabel('quantity')}: ${item.quantity}` }, item.quantity),
        React.createElement("div", { className: "shopping-bag-item-info" },
            React.createElement("div", { className: "product-title", "aria-label": `Item ${index + 1}. ${item.product.name}` }, item.product.name),
            ((_b = item.configurable_options) === null || _b === void 0 ? void 0 : _b.length) &&
                variantsArray.map(variant => (React.createElement("div", { className: "product-option", key: variant }, variant)))),
        React.createElement("div", { className: "shopping-bag-item-price" },
            oldPrice && oldPrice !== newPrice && (React.createElement(React.Fragment, null,
                React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.originalPrice')),
                React.createElement("div", { className: "product-price old strike", "aria-label": `${tLabel('originalPrice')}: ${oldPrice}` }, oldPrice),
                React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.price')))),
            newPrice && (React.createElement("div", { className: "product-price", "aria-label": `${tLabel('price')}: ${newPrice}` }, newPrice)))));
};

export { MiniShoppingCartItem as M };
//# sourceMappingURL=MiniShoppingCartItem-UKpWU5t6.js.map
